import { createRequest } from "helpers/tools";

export const getLeadZohoAuthUrl = async () => {
    return await createRequest({
        suffix: `lead/zoho/auth-url`,
        method: "get",
        handleError: false,
    });
};

export const sendZohoCodeToService = async (data) => {
    return await createRequest({
        suffix: `lead/zoho/store`,
        method: "post",
        payload: data,
        handleError: false,
    });
};
